<template>
  <div>
    <PictureView
      v-model="isImageShow"
      :url="previewImageUrl"
      :scale="4"
      @display="setShowOff"
    ></PictureView>
    <div v-html="content" class="content-body" id="content" ref="content"></div>
    <div class="loading" v-show="loading === true">
      <img style="width:36px;" src="@/assets/loading.svg" />
    </div>
  </div>
</template>
<script>
import PictureView from "@/components/PictureView.vue";

export default {
  name: "Content",
  data() {
    return {
      content: "",
      title: "",
      loading: true,
      isImageShow: false,
      previewImageUrl: ""
    };
  },
  created() {
    const vm = this;
    vm.content = null;
    const contentKey = this.$route.query.key;
    if (contentKey) {
      this.getContent(contentKey).then(response => {
        const resp = response.data;
        if(resp){
          vm.content = resp.data.content;
          vm.title = resp.data.title;
        }
        vm.loading = false;
        vm.renderPreviewImages();
      });
    }
  },
  components: {
    PictureView
  },
  methods: {
    getContent(contentKey) {
      return this.$axios
        .get(`${this.$api.CONTENT_URL}${contentKey}`)
        .then(response => response)
        .catch(err => err);
    },
    renderPreviewImages() {
      this.$nextTick(() => {
        const vm = this;
        const images = this.$refs.content.getElementsByTagName("img");
        for (let i = 0; i < images.length; i += 1) {
          images[i].addEventListener("click", event => {
            event.preventDefault();
            vm.previewImageUrl = images[i].src;
            vm.isImageShow = true;
          });
        }
      });
    },
    setShowOff(display) {
      this.isImageShow = display;
    }
  }
};
</script>
<style scoped>
.content-body {
  padding-left: 30px;
  padding-right: 30px;
  list-style-type: disc;
  list-style: disc inside;
}
</style>
